import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { ClientDetailPage } from "@/features/clients/pages/client-detail-page/client-detail-page";

export const Route = createFileRoute("/_authenticated/admin/clients/$clientId")(
	{
		head: () => pageTitle("Client"),
		component: ClientDetailPage,
	}
);
